import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "../ui/dialog";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { api, formatApiError } from "../../lib/api";

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("New passwords do not match");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password, new_password: form.new_password });
      toast.success("Password changed");
      setForm({ current_password: "", new_password: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const field = (k, label) => (
    <div className="space-y-1.5">
      <Label htmlFor={`cp-${k}`}>{label}</Label>
      <Input id={`cp-${k}`} type="password" required minLength={k === "current_password" ? 1 : 8} value={form[k]}
        onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`change-password-${k}-input`} className="rounded-none bg-white" />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button type="button" data-testid="admin-change-password-button" className="inline-flex items-center gap-2 text-sm font-semibold uppercase">
          <KeyRound className="h-4 w-4" /> Password
        </button>
      </DialogTrigger>
      <DialogContent data-testid="change-password-dialog" className="max-w-sm rounded-none bg-[#f4f0e8]">
        <DialogTitle className="font-display text-2xl font-extrabold uppercase">Change password</DialogTitle>
        <form onSubmit={submit} className="space-y-4">
          {field("current_password", "Current password")}
          {field("new_password", "New password (min 8 characters)")}
          {field("confirm", "Confirm new password")}
          <button type="submit" disabled={busy} data-testid="change-password-submit" className="btn-rust flex w-full items-center justify-center gap-2 py-3 disabled:opacity-60">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Save password
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
